// LENIS INIT
export const lenis = new Lenis({
  duration: 0.8,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  direction: 'vertical',
  gestureDirection: 'vertical',
  smooth: true,
  mouseMultiplier: 0.5,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
});

function observeEditor() {
  const html = document.documentElement;
  const config = { attributes: true, childList: false, subtree: false };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        const btn = document.querySelector(".w-editor-bem-EditSiteButton"),
              bar = document.querySelector(".w-editor-bem-EditorMainMenu");
          
        const addTrig = (target) =>
          target.addEventListener("click", () => lenis.destroy());

        if (btn) addTrig(btn);
        if (bar) addTrig(bar);
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(html, config);
}
observeEditor();

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);